import React, { useState, useEffect, useRef } from 'react';
import { getClass } from 'utils/component-helpers';
import { useOutsideClick } from 'utils/custom-hooks';

import './strategy-labels.scss';

const displayLabels = [
	{name: 'product_launch', label: 'Product Launch'},
	{name: 'sale', label: 'Sale'},
	{name: 'vendor_funded', label: 'Vendor Funded'},
	{name: 'share_of_voice', label: 'Share of Voice'},
	{name: 'preferred_publisher', label: 'Preferred Publisher'},
	{name: 'growth_incentive', label: 'Growth Incentive'},
];

function StrategyLabels({ labelsProp, updateLabels }) {
	/* State */
	const [showDropdown, setShowDropdown] = useState(false);
	const inputNode = useRef(null);

	/* Constants */
	const labels = labelsProp ? labelsProp.split(',') : [];

	/* Effects */
	useOutsideClick(inputNode, setShowDropdown);

	/* Methods */
	function toggleLabels(e, name) {
		e.stopPropagation();
		let newLabels;

		if (labels.includes(name)) {
			newLabels = labels.filter((item) => item !== name);
		} else {
			newLabels = labels.concat(name);
		}

		updateLabels(newLabels.join(',' || null));
	}

	/* Render */
	const labelText = labels.map((item) => {
		const match = displayLabels.find((label) => label.name === item);
		return match.label;
	}).join(', ');

	const dropdownItems = displayLabels.map((label, i) => {
		return (
			<div key={`dropdown-item-${i}`}
				className={getClass('dropdown-item', {
					'selected': labels.includes(label.name),
				})}
				onClick={(e) => toggleLabels(e, label.name)}>
				<div className="checkbox"></div>
				<div className="name">{label.label}</div>
			</div>
		);
	});

	const dropdown = showDropdown ? (
		<div className="label-dropdown">
			{dropdownItems}
		</div>
	) : null;

	return (
		<div className="strategy-labels">
			<div className="label">Label</div>
			<div className="label-container"
				ref={(node) => inputNode.current = node}
				onClick={() => setShowDropdown(!showDropdown)}>
				<div className="label-text">{labelText}</div>
				<div className={`arrow ${showDropdown ? 'open' : ''}`}></div>
				{dropdown}
			</div>
		</div>
	);
}

export default StrategyLabels;
